<template>
    <div class="profile-common__freelancing-experience" :data-testid="props.dataTestid">
        <div class="profile-common__freelancing-experience__cards">
            <div
                v-for="card in freelancingExperienceOptions"
                :key="`freelancing-experience-${card.id.toLowerCase()}`"
                class="profile-common__freelancing-experience__cards__item"
            >
                <FreelancingExperienceCard
                    :data-testid="`freelancing-experience-card--${card.id.toLowerCase()}`"
                    :title="card.title"
                    :name="card.name"
                />
                <a
                    href="#"
                    :class="{selected: selectedLevelOfExperienceAsFreelancerId === card.id}"
                    :data-testid="`freelancing-experience-card--${card.id.toLowerCase()}--link`"
                    @click="handleCardSelectionOnClickOrFocus(card.id)"
                />
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import {toRef} from 'vue';
    import type {FreelancingExperience, FreelancingExperienceId} from '../types/FreelancingExperience';
    import FreelancingExperienceCard from '@/components/freelancing-experience/FreelancingExperienceCard.vue';

    const props = defineProps<{
        dataTestid?: string;
        freelancingExperienceOptions: FreelancingExperience[];
        selectedLevelOfExperienceAsFreelancerId?: FreelancingExperienceId;
    }>();

    const emit = defineEmits<{
        'freelancing-experience:selected': [value: FreelancingExperienceId];
    }>();

    // Refs
    const freelancingExperienceOptions = toRef(props, 'freelancingExperienceOptions');
    const selectedLevelOfExperienceAsFreelancerId = toRef(props, 'selectedLevelOfExperienceAsFreelancerId');

    function handleCardSelectionOnClickOrFocus(levelId: FreelancingExperienceId) {
        emit('freelancing-experience:selected', levelId);

        return false;
    }
</script>
<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .profile-common__freelancing-experience {
        &__cards {
            width: 100%;
            display: flex;
            gap: var(--joy-core-spacing-8);
            align-items: stretch;

            @include mq.screen_xs {
                flex-direction: column;
                gap: var(--joy-core-spacing-1);
            }

            &__item {
                position: relative;
                text-decoration: none;
                color: var(--joy-color-neutral-60);
                flex: 1;
                margin-bottom: var(--joy-core-spacing-6);
                border-radius: var(--joy-core-radius-3);
                min-height: 250px;

                a {
                    position: absolute;
                    inset: 0;
                    border-radius: var(--joy-core-radius-3);

                    &:hover,
                    &:focus,
                    &.selected {
                        border: 2px solid var(--joy-color-secondary-50);
                    }
                }

                @include mq.screen_xs {
                    height: 100px;
                    min-height: 100px;
                }
            }
        }
    }
</style>
